import React from 'react';
interface ChamberProps {
  id: number;
  filled: boolean;
  detecting: boolean;
  spceActive: boolean;
  liquidColor: string;
}
export const Chamber: React.FC<ChamberProps> = ({
  id,
  filled,
  detecting,
  spceActive,
  liquidColor
}) => {
  // Calculate SPCE numbers for this chamber
  // Chamber 1: 1-8, Chamber 2: 9-16, Chamber 3: 17-24, Chamber 4: 25-32
  const startSpceNumber = (id - 1) * 8 + 1;
  return <div className="border-2 border-gray-300 dark:border-gray-600 rounded-lg p-2 flex flex-col items-center relative" data-id="element-30">
      <div className="text-xs font-medium mb-1" data-id="element-31">Chamber {id}</div>
      {/* Chamber content */}
      <div className={`w-full h-24 rounded-md border border-gray-200 dark:border-gray-700 relative overflow-hidden ${!filled ? 'bg-gray-100 dark:bg-gray-800' : ''}`} style={filled ? {
      backgroundColor: liquidColor + '20'
    } : {}} data-id="element-32">
        {/* Liquid fill effect */}
        {filled && <div className="absolute inset-0 opacity-70" style={{
        backgroundColor: liquidColor
      }} data-id="element-33">
            <div className="absolute inset-0 animate-pulse opacity-50" style={{
          backgroundColor: liquidColor
        }} data-id="element-34"></div>
          </div>}
        {/* SPCE sensors (8 per chamber) with numbering */}
        <div className="grid grid-cols-4 grid-rows-2 gap-1 p-1.5 h-full relative z-10" data-id="element-35">
          {Array.from({
          length: 8
        }).map((_, index) => <div key={index} className={`rounded-full border relative flex items-center justify-center ${spceActive ? 'border-green-500 bg-green-200 dark:bg-green-800 animate-pulse' : 'border-gray-400 bg-gray-200 dark:bg-gray-700'}`} data-id="element-36">
              <span className="text-[8px] font-bold text-gray-700 dark:text-gray-300" data-id="element-37">
                {startSpceNumber + index}
              </span>
            </div>)}
        </div>
        {/* Detection animation overlay */}
        {detecting && <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 dark:bg-opacity-50 z-20" data-id="element-38">
            <div className="w-6 h-6 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" data-id="element-39"></div>
          </div>}
      </div>
      {/* Status indicator */}
      <div className="mt-1 text-[10px]" data-id="element-40">
        {detecting ? <span className="text-blue-600 dark:text-blue-400 animate-pulse" data-id="element-41">
            Detecting...
          </span> : filled ? <span className="text-green-600 dark:text-green-400" data-id="element-42">Ready</span> : <span className="text-gray-500" data-id="element-43">Empty</span>}
      </div>
    </div>;
};